module.exports = __webpack_public_path__ + "static/media/levelOfEvidence.19de4589.svg";